import { organizationCreateRoutes, organizationEditRoutes } from './create/routes';
import { TableLayout as OrganizationsTableLayout } from './list/organizations-table/TableLayout';
import { SystemStatusTableLayout } from './list/system-status-table/SystemStatusTableLayout';

import type { PageHandleV2 } from '@/layouts/MainLayout/MainLayout.config';
import type { RouteObject } from 'react-router-dom';

import { OrganizationWizard } from '@/features/Organization/create/OrganizationWizard';

export const organizationRoutes: RouteObject[] = [
	{
		path: '/organizations/create',
		element: <OrganizationWizard />,
		children: organizationCreateRoutes,
	},
	{
		path: '/organizations/:id',
		element: <OrganizationWizard />,
		children: organizationEditRoutes,
	},
];

export const organizationsListRoutes: RouteObject[] = [
	{
		path: 'organizations',
		children: [
			{
				index: true,
				element: <OrganizationsTableLayout />,
				handle: {
					title: 'Organizations',
					displayFilter: true,
					displaySearchFilter: true,
					displayTimeFilter: false,
					actions: [
						{
							type: 'button',
							title: 'New Organization',
							path: '/organizations/create',
						},
					],
				} satisfies PageHandleV2,
			},
		],
	},
	{
		path: 'system-status',
		children: [
			{
				index: true,
				element: <SystemStatusTableLayout />,
				handle: {
					title: 'System Status',
					displayFilter: true,
					displaySearchFilter: true,
					displayTimeFilter: false,
					actions: [],
				} satisfies PageHandleV2,
			},
		],
	},
];
